package songwritersnotebook.platform

import kotlinx.browser.window

private val memoryFileCache = mutableMapOf<String, ByteArray>()

actual class PlatformFile(actual val path: String) {
    actual val name: String = path.substringAfterLast("/")
    actual val absolutePath: String = path
    actual fun exists(): Boolean {
        return if (path.contains("recordings") || path.contains("harmony_temp") || path.endsWith(".m4a") || path.endsWith(".webm") || path.endsWith(".wav") || path.endsWith(".mp3")) {
            memoryFileCache.containsKey(path)
        } else {
            memoryFileCache.containsKey(path) || window.localStorage.getItem(path) != null
        }
    }
    actual fun readText(): String = window.localStorage.getItem(path) ?: memoryFileCache[path]?.decodeToString() ?: ""
    actual fun readBytes(): ByteArray = memoryFileCache[path] ?: readText().encodeToByteArray()
    actual fun writeText(text: String) { window.localStorage.setItem(path, text) }
    actual fun writeBytes(bytes: ByteArray) { 
        if (path.contains("recordings") || path.contains("harmony_temp") || path.endsWith(".m4a") || path.endsWith(".webm") || path.endsWith(".wav") || path.endsWith(".mp3")) {
            memoryFileCache[path] = bytes
        } else {
            writeText(bytes.decodeToString()) 
        }
    }
    actual fun delete(): Boolean {
        val exists = exists()
        window.localStorage.removeItem(path)
        memoryFileCache.remove(path)
        return exists
    }
    actual fun isFile(): Boolean = true
    actual fun isDirectory(): Boolean = false
    actual fun length(): Long = memoryFileCache[path]?.size?.toLong() ?: readText().length.toLong()
    actual fun lastModified(): Long = 0L // Mock for JS
    actual fun listFiles(): List<PlatformFile>? = null
    actual fun mkdirs(): Boolean = true
    actual fun copyTo(target: PlatformFile, overwrite: Boolean) {
        if (overwrite || !target.exists()) {
            if (memoryFileCache.containsKey(path)) {
                memoryFileCache[target.path] = memoryFileCache[path]!!
            } else {
                target.writeText(readText())
            }
        }
    }
}

actual class FileSystem {
    actual fun getAppFilesDirectory(): PlatformFile = PlatformFile("app_data")
    actual fun getCacheDirectory(): PlatformFile = PlatformFile("app_cache")
    actual fun getFile(path: String): PlatformFile = PlatformFile(path)
    actual fun getFile(parent: PlatformFile, child: String): PlatformFile = PlatformFile("${parent.path}_$child")
}

actual fun getPlatformFileSystem(): FileSystem = FileSystem()
